export const userIcon = (
  <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.6673 17.5V15.8333C16.6673 14.9493 16.3161 14.1014 15.691 13.4763C15.0659 12.8512 14.218 12.5 13.334 12.5H6.66732C5.78326 12.5 4.93542 12.8512 4.31029 13.4763C3.68517 14.1014 3.33398 14.9493 3.33398 15.8333V17.5M13.334 5.83333C13.334 7.67428 11.8416 9.16667 10.0007 9.16667C8.1597 9.16667 6.66732 7.67428 6.66732 5.83333C6.66732 3.99238 8.1597 2.5 10.0007 2.5C11.8416 2.5 13.334 3.99238 13.334 5.83333Z"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const mailIcon = (
  <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.3327 5.0026C18.3327 4.08594 17.5827 3.33594 16.666 3.33594H3.33268C2.41602 3.33594 1.66602 4.08594 1.66602 5.0026M18.3327 5.0026V15.0026C18.3327 15.9193 17.5827 16.6693 16.666 16.6693H3.33268C2.41602 16.6693 1.66602 15.9193 1.66602 15.0026V5.0026M18.3327 5.0026L9.99935 10.8359L1.66602 5.0026"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const alertIcon = (
  <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1450_108733)">
      <path
        d="M8.00065 5.33594V8.0026M8.00065 10.6693H8.00732M14.6673 8.0026C14.6673 11.6845 11.6826 14.6693 8.00065 14.6693C4.31875 14.6693 1.33398 11.6845 1.33398 8.0026C1.33398 4.32071 4.31875 1.33594 8.00065 1.33594C11.6826 1.33594 14.6673 4.32071 14.6673 8.0026Z"
        stroke="#F04438"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1450_108733">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const phoneIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 19 18" fill="none">
    <path
      d="M17.3934 11.2607L13.941 9.78067C13.1883 9.45439 12.3013 9.67137 11.7895 10.3063L10.8248 11.484C9.25047 10.5787 7.93176 9.26036 7.02789 7.71876L8.20738 6.75266C8.83703 6.23868 9.0543 5.35696 8.73543 4.60637L7.24727 1.10868C6.89008 0.293054 6.00484 -0.152024 5.14246 0.047312L1.93445 0.787703C1.09492 0.979656 0.507812 1.71688 0.507812 2.58032C0.507812 11.0846 7.42305 17.9999 15.9273 17.9999C16.7908 17.9999 17.528 17.4131 17.6887 16.575L18.4291 13.3638C18.6625 12.4982 18.2125 11.6123 17.3934 11.2607ZM16.8168 12.9834L16.0754 16.197C16.0589 16.2357 16.0012 16.3124 15.927 16.3124C8.35437 16.3124 2.195 10.153 2.195 2.58036C2.195 2.50674 2.24059 2.44908 2.31256 2.43259L5.52373 1.6915C5.53472 1.68875 5.54625 1.68765 5.55724 1.68765C5.6182 1.68765 5.67533 1.72446 5.69951 1.77938L7.181 5.23629C7.20737 5.29838 7.18979 5.37087 7.13705 5.41425L5.42266 6.78887C5.11943 7.03715 5.02715 7.46177 5.19963 7.81333C6.36013 10.1769 8.30252 12.12 10.6664 13.2801C10.9863 13.4526 11.443 13.3603 11.6916 13.0571L13.0982 11.339C13.1372 11.2896 13.2102 11.2709 13.2712 11.2995L16.7257 12.7792C16.7922 12.8393 16.8309 12.9131 16.8168 12.9834Z"
      fill="currentColor"
    />
  </svg>
);
